import { CaseListWithCount, CaseType, SpottedNote } from '@rapid-recovery-agency-inc/insightt-shared';

interface FindAndUpdateModalVehicleDataParams {
  vehicleModalData: CaseType[] | null;
  caseId: number;
  list: CaseType[];
}

export const findAndUpdateModalVehicleData = ({
  vehicleModalData,
  caseId,
  list,
}: FindAndUpdateModalVehicleDataParams) => {
  if (!vehicleModalData) return null;
  const data = list.find((item) => item.caseId === caseId);
  return data;
};

interface UpdateSpottedNoteOnCaseParams {
  spottedNote: SpottedNote;
  caseId: number;
  list: CaseListWithCount[];
}

export const updateSpottedNoteOnCase = ({ list, spottedNote, caseId }: UpdateSpottedNoteOnCaseParams) => {
  if (!list) return list;

  const matchedCase = list.find((c) => c.caseId === caseId);
  if (!matchedCase) return list;

  const mappedCases = list.map((c) => {
    if (c.caseId !== caseId) return c;

    return {
      ...c,
      spottedNotes: [spottedNote, ...c.spottedNotes],
      _count: {
        spottedNotes: c._count.spottedNotes + 1,
      },
    };
  });

  return mappedCases;
};

export const updateSpottedNoteInSNS = ({
  spottedNote,
  currentModalSpottedNotes,
  caseId,
  currentSpottedNotSecured,
}: {
  spottedNote: SpottedNote;
  currentModalSpottedNotes: SpottedNote[];
  caseId: number;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  currentSpottedNotSecured: any;
}) => {
  //spottedNote props should receive the new note
  let updatedSNSListData = [];

  //check the case exists in the current list and saves time if not
  const snsCaseFound = currentSpottedNotSecured.listData.find(
    (snsCase: { caseId: number }) => snsCase.caseId === caseId,
  );

  ////////////////////// currentSpottedNotSecured
  if (currentSpottedNotSecured && snsCaseFound) {
    updatedSNSListData = currentSpottedNotSecured.listData.map((snsCase: CaseListWithCount) => {
      if (snsCase.caseId !== caseId) return snsCase;
      const updatedSNSNotes = snsCase.spottedNotes.map((note) => {
        if (note.id !== spottedNote.id) return note;
        return {
          ...note,
          text: spottedNote.text,
          editedByUser: spottedNote.editedByUser,
          createdAt: spottedNote.createdAt,
        };
      });

      return {
        ...snsCase,
        spottedNotes: [...updatedSNSNotes],
      };
    });
  }

  const updatedModalSpottedNotes = currentModalSpottedNotes.map((note) => {
    if (note.id !== spottedNote.id) return note;
    return {
      ...note,
      text: spottedNote.text,
      editedByUser: spottedNote.editedByUser,
      createdAt: spottedNote.createdAt,
    };
  });

  //Return the updated list
  return {
    updatedSecuredNotSpotted: {
      ...currentSpottedNotSecured,
      listData: updatedSNSListData,
      vehicleModalSpottedNotesData: updatedModalSpottedNotes,
    },
  };
};

export const deleteSpottedNoteInSNS = ({
  spottedNote,
  currentModalSpottedNotes,
  caseId,
  currentSpottedNotSecured,
}: {
  spottedNote: SpottedNote;
  currentModalSpottedNotes: SpottedNote[];
  caseId: number;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  currentSpottedNotSecured: any;
}) => {
  //spottedNote props should receive the new note
  let updatedSNSListData = [];

  //check the case exists in the current list and saves time if not
  const snsCaseFound = currentSpottedNotSecured.listData.find(
    (snsCase: { caseId: number }) => snsCase.caseId === caseId,
  );

  ////////////////////// currentSpottedNotSecured
  if (currentSpottedNotSecured && snsCaseFound) {
    updatedSNSListData = currentSpottedNotSecured.listData.map((snsCase: CaseListWithCount) => {
      if (snsCase.caseId !== caseId) return snsCase;

      //After case being found, look for the note on a map, and don't return it.
      const updatedSNSNotes = snsCase.spottedNotes.filter((note) => note.id !== spottedNote.id);

      return {
        ...snsCase,
        _count: { spottedNotes: snsCase._count.spottedNotes - 1 },
        spottedNotes: [...updatedSNSNotes],
      };
    });
  }

  const updatedModalSpottedNotes = currentModalSpottedNotes.filter((note) => {
    return note.id !== spottedNote.id;
  });

  //Return the updated list
  return {
    updatedSecuredNotSpotted: {
      ...currentSpottedNotSecured,
      listData: updatedSNSListData,
      vehicleModalSpottedNotesData: updatedModalSpottedNotes,
    },
  };
};
